import apiRequest from './apiRequest';

interface VerifyEmailResponse {
    success: boolean;
}

export default async function getVerifyEmail(
    email: string,
    code: string,
    excitedAbout?: string,
) {
    const params = new URLSearchParams({ email, code });
    if (excitedAbout) {
        params.set('excitedAbout', excitedAbout);
    }
    const { data, error } = await apiRequest<VerifyEmailResponse>(
        'user',
        `/users/verifyEmail?${params.toString()}`,
        {
            method: 'GET',
        },
    );

    return { data, error };
}
